import {NgModule} from '@angular/core';
import {SlidePanelComponent} from './slide_panel.component';


@NgModule({
  exports: [SlidePanelComponent],
  declarations: [
    SlidePanelComponent
  ]
})
export class ElementsModule {
}
